import api from "./client";

export const getAnalyticsDashboard = (params = {}) => {
    return api.get("/api/analytics/dashboard/", {
        params,
    });
};

export const getAnalyticsClinics = (params = {}) => {
    return api.get("/api/analytics/clinics/", { params });
};
